function initializeCartCheck() {
  const intervalId = setInterval(() => {
    const shadowHost = document.querySelector("#upCart");
    if (!shadowHost) {
      return;
    }

    const shadowRoot = shadowHost.shadowRoot;
    const cartContainer = shadowRoot.querySelector(".upcart-cart");

    if (!cartContainer) {
      return;
    }

    initializeCartObserver(cartContainer);
    clearInterval(intervalId);
  }, 300);
}

function initializeCartObserver(cartContainer) {
  const observer = new MutationObserver(() => {
    const itemsContainer = cartContainer.querySelector(".upcart-products-section");
    if (itemsContainer) {
      observer.disconnect();
      handleCartUpdates(itemsContainer);
      addDiscountBadge(cartContainer);
      observer.observe(cartContainer, { childList: true, subtree: true });
    }
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true,
  });

  const itemsContainer = cartContainer.querySelector(".upcart-products-section");
  if (itemsContainer) {
    handleCartUpdates(itemsContainer);
    addDiscountBadge(cartContainer);
  }
}

/* ---- crossword thumbnail: render the customer's ACTUAL layout as an SVG ----
   The builder stores the grid on every letter line as the `layout` property
   ("','-separated cells, '|'-separated rows"), plus `Finish`. We draw it. */

const CROSSWORD_FINISH_COLORS = {
  Natural: { tile: "#EDE3CC", edge: "#CBBD9F", text: "#2B2620" },
  White:   { tile: "#FAFAF6", edge: "#D8D8D2", text: "#2B2B2B" },
  Rustic:  { tile: "#EAE0D1", edge: "#C4B49B", text: "#4A4238" },
  Walnut:  { tile: "#6B4A32", edge: "#513723", text: "#F5EDE2" },
};

function crosswordLayoutSvg(layoutStr, finish) {
  try {
    const rows = layoutStr.split("|").map((r) => r.split(","));
    const h = rows.length;
    const w = Math.max.apply(null, rows.map((r) => r.length));
    if (!h || !w) return null;
    const CELL = 20, PAD = 4, R = 2.5;
    const width = w * CELL + PAD * 2;
    const height = h * CELL + PAD * 2;
    const c = CROSSWORD_FINISH_COLORS[finish] || CROSSWORD_FINISH_COLORS.Natural;
    let tiles = "";
    let tileCount = 0;
    for (let r = 0; r < h; r++) {
      for (let col = 0; col < w; col++) {
        const ch = (rows[r][col] || "").trim();
        if (!/^[A-Za-z]$/.test(ch)) continue;
        tileCount++;
        const x = PAD + col * CELL, y = PAD + r * CELL;
        tiles +=
          `<rect x="${x + 0.8}" y="${y + 0.8}" width="${CELL - 1.6}" height="${CELL - 1.6}" rx="${R}" ` +
          `fill="${c.tile}" stroke="${c.edge}" stroke-width="1"/>` +
          `<text x="${x + CELL / 2}" y="${y + CELL / 2 + 4.5}" text-anchor="middle" ` +
          `font-family="Georgia,serif" font-weight="bold" font-size="12" fill="${c.text}">${ch.toUpperCase()}</text>`;
      }
    }
    if (!tileCount) return null; // nothing to draw — let the caller fall back to the stock image
    const svg =
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" width="${width}" height="${height}">` +
      `<rect width="${width}" height="${height}" fill="white"/>${tiles}</svg>`;
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  } catch (e) {
    return null;
  }
}

// read a property value from an UpCart item row ("Key" strong + value span pairs)
function readItemProperty(productItem, key) {
  const strongs = productItem.querySelectorAll(".upcart-item-property strong");
  for (const s of strongs) {
    if (s.textContent.replace(":", "").trim().toLowerCase() === key.toLowerCase()) {
      const span = s.parentElement ? s.parentElement.querySelector("span") : null;
      const val = span ? span.textContent.trim() : (s.nextElementSibling ? s.nextElementSibling.textContent.trim() : "");
      return { value: val, strong: s, span: span };
    }
  }
  return null;
}

function hideItemProperty(productItem, key) {
  const prop = readItemProperty(productItem, key);
  if (prop) {
    if (prop.strong && prop.strong.parentElement) prop.strong.parentElement.style.display = "none";
    else {
      if (prop.strong) prop.strong.style.display = "none";
      if (prop.span) prop.span.style.display = "none";
    }
  }
  return prop ? prop.value : null;
}

function handleCartUpdates(itemsContainer) {
  const productItems = Array.from(itemsContainer.children);

  const groupedItems = {};

  productItems.forEach((productItem) => {
    const crosswordIdElement = productItem.querySelector(".upcart-item-property strong");
    const crosswordIdValueElement = productItem.querySelector(
      ".upcart-item-property span"
    );

    if (crosswordIdElement && crosswordIdElement.textContent.includes("crossword_id")) {
      crosswordIdElement.style.display = "none";
      crosswordIdValueElement.style.display = "none";
      const crosswordId = crosswordIdValueElement.textContent.trim();

      if (!groupedItems[crosswordId]) {
        groupedItems[crosswordId] = [];
      }
      groupedItems[crosswordId].push(productItem);
    } else {
      productItem.dataset.isGrouped = "false";
    }
  });

  Object.keys(groupedItems).forEach((crosswordId) => {
    const group = groupedItems[crosswordId];

    const primaryItem = group[0];
    primaryItem.dataset.isGrouped = "true";

    // hide the raw layout/finish/builder-qty property rows everywhere in the group
    let layoutStr = null;
    let finish = null;
    group.forEach((item) => {
      const l = hideItemProperty(item, "layout");
      if (l && !layoutStr) layoutStr = l;
      const f = hideItemProperty(item, "Finish");
      if (f && !finish) finish = f;
      hideItemProperty(item, "_Builder QTY");
    });
    // finish fallback from product title: "Crossword Wall Tile - White"
    if (!finish) {
      const titleEl = primaryItem.querySelector("a");
      const m = titleEl && titleEl.textContent.match(/Crossword Wall Tile\s*-\s*(\w+)/);
      finish = m ? m[1] : "Natural";
    }

    if (!primaryItem.querySelector(".btn-custom-delete")) {
      const deleteButton = document.createElement("button");
      deleteButton.className = "btn-custom-delete";
      deleteButton.innerHTML = `<svg class="hover-svg" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="currentColor" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path>  <path d="M2.34375 3.28125H12.6562H2.34375Z" fill="currentColor"></path>  <path    d="M2.34375 3.28125H12.6562"    stroke="currentColor"    stroke-width="0.9375"    stroke-miterlimit="10"    stroke-linecap="round"  ></path>  <path    d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="currentColor" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
      deleteButton.setAttribute("data-crossword-id", crosswordId);

      deleteButton.addEventListener("click", () => {
        const loader = document.createElement("div");
        loader.classList.add("styles_ProductRow__loader__");
        primaryItem.prepend(loader);
        primaryItem.style.opacity = "0.5";
        primaryItem.style.pointerEvents = "none";
        removeGroupItems(group);
      });

      // thumbnail: the customer's actual crossword, not a stock photo
      const image = primaryItem.querySelector("a img");
      if (image) {
        const svgUri = layoutStr ? crosswordLayoutSvg(layoutStr, finish) : null;
        if (svgUri) {
          image.src = svgUri;
          image.style.objectFit = "contain";
          image.style.background = "#fff";
        } else {
          image.src =
            "https://cdn.shopify.com/s/files/1/0276/1519/9267/files/CrosswordWallTiles.png?v=1698771791&width=100";
        }
      }

      // Show selected words
      let totalQuantity = 0;
      group.forEach((item) => {
        totalQuantity += parseInt(
          item.querySelector(".upcart-product-quantity-input").value
        );
      });
      const totalLetters = primaryItem.querySelector(".upcart-item-option");
      totalLetters.innerHTML = `
              <div class="cart-total-letters">
                <img src="https://cdn.shopify.com/s/files/1/0276/1519/9267/files/total-letters.png?v=1737984565&width=20">
                <p>${totalQuantity} letters · ${finish}</p>
              </div>`;

      // Show price per product and counter
      const totalPriceElement = primaryItem.querySelector(".upcart-item-price");
      const totalPriceText = totalPriceElement.textContent.trim();
      const totalPriceNumber = parseFloat(totalPriceText.replace("$", "").trim());
      const productQuantity = parseInt(
        primaryItem.querySelector(".upcart-product-quantity-input").value,
        10
      );

      const pricePerProduct = (totalPriceNumber / productQuantity).toFixed(2);
      const priceSection = document.createElement("div");
      priceSection.className = "price-per-product";
      priceSection.innerHTML = `<p>$${pricePerProduct} per letter</p>`;

      priceSection.append(deleteButton);
      const stackElement = primaryItem.querySelector(".Stack--distributionEqualSpacing");
      stackElement.parentNode.insertBefore(priceSection, stackElement);
    }

    // Hide all but the first item of the group
    group.slice(1).forEach((item) => {
      item.style.display = "none";
      item.dataset.isGrouped = "true";
    });
  });
}

function removeGroupItems(group) {
  const updates = {};

  group.forEach((productItem) => {
    const itemId = productItem.id;
    if (itemId) {
      updates[itemId] = 0;
    }
  });

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      if (response.ok) {
        if (typeof window.upcartRefreshCart === "function") {
          window.upcartRefreshCart();
        }
      } else {
        console.error("Failed to remove group items.");
      }
    })
    .catch((error) => {
      console.error("Error removing group items:", error);
    });
}

function addDiscountBadge(cartContainer) {
  // Fetch cart data to get discount information
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Remove existing discount sections if they exist
      const existingOriginalTotal = cartContainer.querySelector(".upcart-original-total");
      const existingDiscount = cartContainer.querySelector(".upcart-discount-section");
      if (existingOriginalTotal) {
        existingOriginalTotal.remove();
      }
      if (existingDiscount) {
        existingDiscount.remove();
      }

      // Check if there are cart-level discounts
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        // Find the subtotal section
        const subtotalSection = cartContainer.querySelector(".styles_Footer__cartSubtotalTitle__");

        if (subtotalSection) {
          // Wait for subtotal to be populated, then use its currency format
          const waitForSubtotal = () => {
            const subtotalValueElement = subtotalSection.querySelector(".styles_Footer__cartSubtotalValue__");
            if (!subtotalValueElement || !subtotalValueElement.textContent.trim()) {
              // Subtotal not ready yet, wait a bit more
              setTimeout(waitForSubtotal, 100);
              return;
            }

            // Calculate original total (current total + discount amount)
            let totalDiscountAmount = 0;
            cart.cart_level_discount_applications.forEach((discount) => {
              totalDiscountAmount += discount.total_allocated_amount;
            });
            const originalTotal = cart.total_price + totalDiscountAmount;

            // Get currency format from subtotal element
            const subtotalText = subtotalValueElement.textContent.trim();
            const currencyFormat = detectCurrencyFromText(subtotalText);

            // Create original total section (same style as subtotal) - use subtotal currency
            const originalTotalSection = document.createElement("div");
            originalTotalSection.className = "styles_Footer__cartSubtotalTitle__ styles_Footer__alignLeft__ UpcartDesignSettings__subtotalTextColor upcart-original-total";
            originalTotalSection.style.cssText = "margin-bottom: 4px;";
            originalTotalSection.innerHTML = `
              <span>Total</span>
              <span class="styles_Footer__cartSubtotalValue__ styles_Footer__alignRight__ UpcartDesignSettings__subtotalTextColor">${formatMoneyWithCurrency(originalTotal, currencyFormat)}</span>
            `;

            // Create discount section for each discount (same style as subtotal)
            const discountContainer = document.createElement("div");
            discountContainer.className = "upcart-discount-section";
            discountContainer.style.cssText = "margin-bottom: 4px;";

            cart.cart_level_discount_applications.forEach((discount) => {
              const discountSection = document.createElement("div");
              discountSection.className = "styles_Footer__cartSubtotalTitle__ styles_Footer__alignLeft__ UpcartDesignSettings__subtotalTextColor";
              discountSection.style.cssText = "margin-bottom: 2px;";

              // Use innerHTML to match exact structure of Total/Subtotal
              discountSection.innerHTML = `
                <span style="display: inline-flex; align-items: center; gap: 6px;">
                  <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12" style="width: 12px; height: 12px; fill: currentColor;">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
                  </svg>
                  ${discount.title}
                </span>
                <span class="styles_Footer__cartSubtotalValue__ styles_Footer__alignRight__ UpcartDesignSettings__subtotalTextColor">-${formatMoneyWithCurrency(discount.total_allocated_amount, currencyFormat)}</span>
              `;

              discountContainer.appendChild(discountSection);
            });

            // Insert the sections above the subtotal
            subtotalSection.parentNode.insertBefore(originalTotalSection, subtotalSection);
            subtotalSection.parentNode.insertBefore(discountContainer, subtotalSection);
          };

          // Start waiting for subtotal
          waitForSubtotal();
        }
      }
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}

function detectCurrencyFromText(text) {
  if (!text) return { symbol: '$', position: 'before' };

  // Check for different currency symbols and their positions
  if (text.includes('€')) {
    const position = text.indexOf('€') === 0 ? 'before' : 'after';
    const useComma = text.includes(',');
    return { symbol: '€', position, useComma };
  } else if (text.includes('$')) {
    const position = text.indexOf('$') === 0 ? 'before' : 'after';
    return { symbol: '$', position };
  } else if (text.includes('£')) {
    const position = text.indexOf('£') === 0 ? 'before' : 'after';
    return { symbol: '£', position };
  } else if (text.includes('¥')) {
    const position = text.indexOf('¥') === 0 ? 'before' : 'after';
    return { symbol: '¥', position, noDecimals: true };
  }

  // Default to dollar
  return { symbol: '$', position: 'before' };
}

function formatMoneyWithCurrency(cents, currencyFormat) {
  const amount = currencyFormat.noDecimals ?
    Math.round(cents / 100).toString() :
    (cents / 100).toFixed(2);

  // Use comma as decimal separator for European currencies if detected
  const formattedAmount = currencyFormat.useComma ?
    amount.replace('.', ',') :
    amount;

  if (currencyFormat.position === 'before') {
    return `${currencyFormat.symbol}${formattedAmount}`;
  } else {
    return `${formattedAmount}${currencyFormat.symbol}`;
  }
}

initializeCartCheck();
